import { AccessAuditDetails } from '@types';
import { DynamicQueryParams } from '@sonar-software/sonar-ts-types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type GetDataSecurityAccessAuditByIdRequest = DynamicQueryParams & {
	salesforceId: string;
};

export type GetDataSecurityAccessAuditByIdResponse = Array<AccessAuditDetails>;

export const getDataSecurityAccessAuditById =
	createGetEndpoint<GetDataSecurityAccessAuditByIdRequest, GetDataSecurityAccessAuditByIdResponse>(
		({ salesforceId, ...rest }) =>
			`/api/v3/salesforce/data-access/who-has-access/${salesforceId}?${getQueryString(rest)}`
	);
